import { ListingDraft, TradeRecord, TradeStatus, WithdrawalDraft, WithdrawalRecord } from './marketplaceTypes';

export const MARKETPLACE_POLICY = {
  listing: {
    minCredits: 10,
    maxCredits: 200000,
    maxTitleLength: 120,
    maxBannerLength: 120,
    maxDescriptionLength: 300,
  },
  withdrawal: {
    minAmount: 50,
  },
  integrity: {
    immutableStatuses: ['completed', 'refunded', 'disputed'] as TradeStatus[],
  },
};

export function validateListingDraft(draft: ListingDraft): string | null {
  const parsedCredits = Number(draft.credits);
  if (!draft.title.trim()) return 'Tên sản phẩm là bắt buộc.';
  if (!draft.banner.trim()) return 'Banner sản phẩm là bắt buộc.';
  if (!draft.description.trim()) return 'Mô tả sản phẩm là bắt buộc.';
  if (!Number.isFinite(parsedCredits)) return 'Giá credits không hợp lệ.';
  if (parsedCredits < MARKETPLACE_POLICY.listing.minCredits) {
    return `Giá tối thiểu là ${MARKETPLACE_POLICY.listing.minCredits} credits.`;
  }
  if (parsedCredits > MARKETPLACE_POLICY.listing.maxCredits) {
    return `Giá tối đa là ${MARKETPLACE_POLICY.listing.maxCredits} credits.`;
  }
  if (draft.title.trim().length > MARKETPLACE_POLICY.listing.maxTitleLength) {
    return `Tên sản phẩm vượt quá ${MARKETPLACE_POLICY.listing.maxTitleLength} ký tự.`;
  }
  if (draft.banner.trim().length > MARKETPLACE_POLICY.listing.maxBannerLength) {
    return `Banner vượt quá ${MARKETPLACE_POLICY.listing.maxBannerLength} ký tự.`;
  }
  if (draft.description.trim().length > MARKETPLACE_POLICY.listing.maxDescriptionLength) {
    return `Mô tả vượt quá ${MARKETPLACE_POLICY.listing.maxDescriptionLength} ký tự.`;
  }
  return null;
}

export function computeWithdrawableCredits(trades: TradeRecord[]): number {
  return trades
    .filter((trade) => trade.side === 'sell' && trade.status === 'completed')
    .reduce((sum, trade) => sum + trade.credits, 0);
}

export function computePendingWithdrawalCredits(withdrawals: WithdrawalRecord[]): number {
  return withdrawals
    .filter((item) => item.status === 'pending')
    .reduce((sum, item) => sum + item.amount, 0);
}

export function validateWithdrawalDraft(
  draft: WithdrawalDraft,
  trades: TradeRecord[],
  withdrawals: WithdrawalRecord[],
): string | null {
  const amount = Number(draft.amount);
  const withdrawable = computeWithdrawableCredits(trades);
  const pending = computePendingWithdrawalCredits(withdrawals);
  const available = withdrawable - pending;

  if (!Number.isFinite(amount)) return 'Số credits rút không hợp lệ.';
  if (amount < MARKETPLACE_POLICY.withdrawal.minAmount) {
    return `Mức rút tối thiểu là ${MARKETPLACE_POLICY.withdrawal.minAmount} credits.`;
  }
  if (amount > available) return 'Số credits rút vượt quá phần có thể rút.';
  if (!draft.destination.trim()) return 'Tài khoản nhận tiền là bắt buộc.';
  return null;
}

export function isTradeMutable(status: TradeStatus): boolean {
  return !MARKETPLACE_POLICY.integrity.immutableStatuses.includes(status);
}
